document.addEventListener("DOMContentLoaded", function () {

  // =========================
  // 🔹 IMAGE HOVER CODE
  // =========================
  const items = document.querySelectorAll(".diamond-item");
  const mainImage = document.querySelector(".main-ring-image");

  if (mainImage) {
    const defaultImage = mainImage.src;

    items.forEach(item => {

      const hoverImage = item.getAttribute("data-hover-image");
      const resetImage = item.getAttribute("data-default-image") || defaultImage;

      // Hover IN
      item.addEventListener("mouseenter", () => {
        if (hoverImage) {
          mainImage.style.opacity = "0";

          setTimeout(() => {
            mainImage.src = hoverImage;
            mainImage.style.opacity = "1";
          }, 150);
        }
      });

      // Hover OUT
      item.addEventListener("mouseleave", () => {
        mainImage.style.opacity = "0";

        setTimeout(() => {
          mainImage.src = resetImage;
          mainImage.style.opacity = "1";
        }, 150);
      });

    });
  }

  // FAQ Accordion Fix (Shopify Safe)
  document.addEventListener("click", function (e) {

    const btn = e.target.closest(".faq-question");
    if (!btn) return;

    const item = btn.parentElement;
    const isActive = item.classList.contains("active");

    // Close all
    document.querySelectorAll(".faq-item").forEach(el => {
      el.classList.remove("active");
      const icon = el.querySelector("span");
      if (icon) icon.textContent = "+";
    });

    // Open clicked
    if (!isActive) {
      item.classList.add("active");
      const icon = btn.querySelector("span");
      if (icon) icon.textContent = "-";
    }

  });

});